export const Uri = {
  Audience: {
    Aggregate: 'Audience/Aggregate',
    AggregateMultiRfm: '/Audience/aggregate/multi-rfm',
    ClientTags: 'Audience/ClientTags',
    Composite: 'AudienceComposite',
    Details: 'Audience/Details',
    DetailsMultiRfm: 'Audience/Details/multi-rfm',
    Donations: 'Audience/Donations',
    Export: 'Audience/Export',
    MailTags: 'Audience/MailTags',
    MasterFile: 'Audience/MasterFile',
    MasterFiles: 'Audience/MasterFiles',
    Omits: 'OmitFlags',
    PreBuilt: 'Audience/Prebuilt',
    PreviousAbOrders: 'PreviousABOrders',
    PreviousHouseOrder: 'PreviousHouseOrders',
    PreviousListRentals: 'PreviousListRentals',
    Results: 'Audience',
    ResultsMultiRfm: 'Audience/multi-rfm',
    Save: 'Audience/Shop',
    SaveMasterFileMultiRfm: 'Audience/MasterFile/multi-rfm',
    SavePreBuiltMultiRfm: 'Audience/Prebuilt/multi-rfm',
    Tags: 'Audience/Tags',
    UpdateMasterFile: 'Audience/MasterFile/{0}',
    UpdateMasterFileMultiRfm: 'Audience/MasterFile/multi-rfm/{0}',
    UpdatePreBuilt: 'Audience/Prebuilt/{0}',
    UpdatePreBuiltMultiRfm: 'Audience/Prebuilt/multi-rfm/{0}',
  },
  Authentication: {
    Token: {
      extend: 'token/extend',
      login: 'token',
      refresh: 'token/refresh',
      revoke: 'token/revoke',
    },
  },
  Client: {
    Bluebook: 'Bluebook/Clients',
    CampaignName: 'Client/CampaignName',
    CampaignTotal: 'Client/CampaignTotal',
    ClientLists: 'ClientLists',
    Clients: 'Clients',
    IncidentalAccounts: 'Client/IncidentalAccounts',
    IncidentalCosts: 'Client/IncidentalCosts',
    IncidentalLists: 'Client/IncidentalList',
    ListRental: 'Client/ListRental',
    ListRentalTotal: 'Client/ListRentalTotal',
    MailList: 'Client/MailList',
    MailType: 'Client/MailType',
    MailTypeTotal: 'Client/MailTypeTotal',
    PhaseName: 'Client/PhaseName',
    PhaseTotal: 'Client/PhaseTotal',
    Prospect: 'Client/Prospect',
    WhiteMailIncome: 'Client/WhiteMailIncome',
    WhiteMailTotal: 'Client/WhiteMailTotal',
  },
  Dailies: {
    Calendar: {
      day: 'dailies/calendar/daily',
      month: 'dailies/calendar/{0}/{1}',
      year: 'dailies/calendar/{0}',
    },
    Dailies: 'Dailies',
    File: 'Dailies/file',
    History: 'Dailies/history',
    MailCodes: 'Dailies/mail-codes',
    Summary: 'Dailies/history/summary',
    whiteMail: 'Dailies/mail-codes/wm',
  },
  DataDictionary: {
    DataPoints: 'data-dictionary/data-points',
    Sources: 'data-dictionary/sources',
    TextValues: 'data-dictionary/text-values',
  },
  Exceptions: 'dailies/Exceptions',
  Export: {
    Audience: 'Export/Audience',
    Shop: 'Export/Shop',
  },
  ExternalList: 'ExternalList',
  File: {
    Criteria: 'File/Criteria',
  },
  GetDonorComposite: 'donor/composite',
  GetMailByState: 'mail/state',
  GetMailInsights: 'mail/insights',
  GetMailPerformance: 'mail/performance',
  GetTop5ClientMailing: 'client/mailing/top5',
  ListPerformance: {
    ListPerformance: 'ListPerformance',
    Managers: 'ListPerformance/managers',
    Names: 'ListPerformance/names',
    Owners: 'ListPerformance/owners',
    Segments: 'ListPerformance/segments',
  },
  Lookup: {
    Districts: 'CongressionalDistricts',
    MailCodes: 'MailCodes',
    PackageCodes: 'PackageCodes',
    States: 'States',
    Tags: 'Lookup/Tags',
  },
  LRI: {
    File: 'LRI/file',
    LRI: 'LRI',
  },
  Nls: {
    Create: 'Nls/CreateNlsOrder',
    GetAll: 'GetNlsOrders',
  },
  Notification: {
    DeleteAll: 'notification',
    Get: 'notification/{0}',
    GetAll: 'notification',
    Read: 'notification/{0}/read',
    ReadAll: 'notification/read',
    SendAll: 'notification/all',
    SendGroup: 'notification/group',
    SendUser: 'notification/user',
  },
  PostEditJwtProfile: 'post-jwt-profile',
  PostEditProfile: 'post-fake-profile',
  PostFakeJwtPasswordForget: 'jwt-forget-pwd',
  PostFakeJwtRegister: 'post-jwt-register',
  PostFakePasswordForget: 'fake-forget-pwd',
  PostFakeRegister: 'post-fake-register',
  Returns: {
    CagingHistory: 'Returns/CagingHistory',
    Clients: 'Returns/Clients',
    Incidentals: 'Returns/incidentals',
    LRI: 'Returns/lri',
    MailTypes: 'Returns/MailTypes',
    Package: 'Returns/package',
    Return: 'Returns',
    WhiteMail: 'Returns/white-mail',
  },
  SecretKey: 'secret/generate',
  ShippingLog: {
    GetLog: 'GetBillingLog',
  },
  SortAudienceMailCodes: 'MailCodes/Sort',
  User: {
    ActivateAudience: 'User/ActivateAudience',
    Audience: 'User/Audience',
    AudienceShop: 'User/AudienceShop',
    AudienceShopMultiRfm: 'User/AudienceShop/multi-rfm',
    AudienceStatus: 'User/Audience/{0}/Status',
    Dashboard: 'User/Dashboard',
    GetMailCode: 'User/Audience/Shop/MailCode',
    Names: 'User/Audience/Names',
    PasswordChange: 'User/Password/Change',
    PasswordRules: 'User/Password/Rules',
    Shop: 'User/Shop/{0}',
    Shops: 'User/Audience/{0}/Shop',
    UpdateAudienceShop: 'User/AudienceShop/{0}',
    UpdateAudienceShopMultiRfm: 'User/AudienceShop/multi-rfm/{0}',
    User: 'User',
    Users: 'User/Users',
  },
  Utilities: {
    Pdf: {
      download: 'utilities/Pdf/download',
      getPDFs: 'utilities/Pdf',
      upload: 'utilities/Pdf',
    },
    Whitemail: 'utilities/Whitemail',
  },
} as const;
